// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class UserAccountStatusNames {
    public static readonly PENDING_APPROVAL: string = 'Pending Approval';
    public static readonly APPROVED: string = 'Approved';
    public static readonly REJECTED: string = 'Rejected';
    public static readonly INACTIVE: string = 'Inactive';
}
